import { Component, OnInit } from '@angular/core';
import { DataStoreService } from '../data-store.service';

@Component({
  selector: 'redirecting',
  templateUrl: './redirecting.component.html',
  styleUrls: ['./redirecting.component.scss']
})
export class RedirectingComponent implements OnInit {
  constructor(
    private dataStoreService: DataStoreService
  ) { }

  ngOnInit() {
    this.dataStoreService.saveFinalResponse(JSON.parse(sessionStorage.FinalResponse));
    var link = this.dataStoreService.getFinalResponse().AuthenticationLink;
    
    setTimeout(() => {
      window.location.href = link;
    }, 5000);
  }

}
